import { createContext, ReactNode, useCallback, useState } from 'react';

export const LanguageContext = createContext<{
  t: (en: string, de?: string | null) => string;
  toggleLang: () => void;
}>({
  t: () => {
    throw Error('Language context not configured');
  },
  toggleLang: () => {
    throw Error('Language context not configured');
  },
});

export default function LanguageWrapper({ children }: { children: ReactNode }) {
  const [langDe, setLangDe] = useState(false);

  const toggleLang = useCallback(() => {
    setLangDe((current) => !current);
  }, []);

  const t = useCallback(
    (en: string, de?: string | null) => {
      return langDe ? (de ? de : en) : en;
    },
    [langDe]
  );

  return (
    <>
      <LanguageContext.Provider value={{ t, toggleLang }}>
        {children}
      </LanguageContext.Provider>
    </>
  );
}
